export const AlreadyValidated = ({page}) => {
    return (
        <>{page} already validated.</>
    )
}

export const ValidatedSuccessfully = ({page}) => {
    return (
        <>{page} validated successfully.</>
    )
}

export const SavedSuccessfully = ({page}) => {
    return (
        <>{page} saved successfully.</>
    )
}

export const SkipSaving = ({page}) => {
    return (
        <>Saving {page} skipped. Already Validated.</>
    )
}

export const UpdatedSuccessfully = ({page}) => {
    return (
        <>{page} updated successfully.</>
    )
}

export const Saving = ({page}) => {
    return (
        <>Saving {page}...</>
    )
}